var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 23.3512C0 22.9401 0.163303 22.5459 0.453984 22.2552C0.744666 21.9645 1.13891 21.8012 1.55 21.8012H20.15C20.5611 21.8012 20.9553 21.9645 21.246 22.2552C21.5367 22.5459 21.7 22.9401 21.7 23.3512C21.7 23.7623 21.5367 24.1566 21.246 24.4472C20.9553 24.7379 20.5611 24.9012 20.15 24.9012H1.55C1.13891 24.9012 0.744666 24.7379 0.453984 24.4472C0.163303 24.1566 0 23.7623 0 23.3512ZM5.10415 7.39708C4.81357 7.10641 4.65033 6.71224 4.65033 6.30123C4.65033 5.89023 4.81357 5.49605 5.10415 5.20538L9.75415 0.555381C10.0448 0.264801 10.439 0.101563 10.85 0.101562C11.261 0.101562 11.6552 0.264801 11.9459 0.555381L16.5958 5.20538C16.8782 5.49772 17.0344 5.88925 17.0309 6.29565C17.0274 6.70206 16.8644 7.09082 16.577 7.3782C16.2896 7.66558 15.9008 7.8286 15.4944 7.83213C15.088 7.83566 14.6965 7.67943 14.4042 7.39708L12.4 5.39293V17.1512C12.4 17.5623 12.2367 17.9566 11.946 18.2472C11.6553 18.5379 11.2611 18.7012 10.85 18.7012C10.4389 18.7012 10.0447 18.5379 9.75399 18.2472C9.4633 17.9566 9.3 17.5623 9.3 17.1512V5.39293L7.29585 7.39708C7.00518 7.68766 6.611 7.8509 6.2 7.8509C5.789 7.8509 5.39482 7.68766 5.10415 7.39708Z",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.84d24d7675f290a7e620abe2b6615105.svg";
export { ForwardRef as ReactComponent };